import React from 'react';
import TimerIcon from '@mui/icons-material/Timer';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {CertificationPhase, Project, ProjectStatus} from '../../../../store/projects/commonTypes';
import PhaseStepper from "../../../stepper/Stepper";
import {certificationStatusOptions, getOptionLabel, projectStatusOptions} from "../../../../utils/utils";

export interface ProjectStepperProps {
    project: Project;
}

const icons = [
    <TimerIcon />,
    <VerifiedUserIcon />,
    <AutorenewIcon />,
    <CheckCircleOutlineIcon />,
];

const getActiveStep = (project: Project): number => {
    switch (project.projectStatus) {
        case ProjectStatus.reportResendInProgress:
        case ProjectStatus.delayed:
        default:
            return 2; // "Sertifiseringsprosess"
        case ProjectStatus.qaCompleted:
            return 3; // "Sertifiseringsprosess fullført"
        case ProjectStatus.registered:
            return 1; // "Registrert"
        case ProjectStatus.onReview:
            return 0; // "Godkjening"
    }
};

const ProjectStepper: React.FC<ProjectStepperProps> = ({ project }) => {
    const activeStep = getActiveStep(project);

    return (
        <div className="row d-flex justify-content-center mt-4 mb-4">
            <PhaseStepper
                steps={[
                    getOptionLabel(projectStatusOptions, ProjectStatus.onReview),
                    getOptionLabel(projectStatusOptions, ProjectStatus.registered),
                    getOptionLabel(projectStatusOptions, ProjectStatus.qaInProgress),
                    getOptionLabel(projectStatusOptions, ProjectStatus.qaCompleted)
                ]}
                activeStep={activeStep} 
                icons={icons} />
        </div>
    );
};

export default ProjectStepper;